export default "__VITE_ASSET__Cg3M3J1o__"